import { publicAsset } from "@/shared/config/env";
import { cn } from "@/shared/lib/utils";

/** Assinatura "Powered by edx". `compact` = linha única discreta (rodapé da sidebar). */
export function PoweredByEdx({ className = "", compact = false }: { className?: string; compact?: boolean }) {
  if (compact) {
    return (
      <div className={cn("flex items-center gap-2 text-caption text-fg-subtle", className)}>
        <span>Powered by</span>
        <span className="inline-flex items-center rounded-sm bg-[#0a0a0a] px-1.5 py-0.5">
          <img src={publicAsset("edx-logo.png")} alt="edx" width={44} height={16} className="h-3.5 w-auto" loading="lazy" decoding="async" />
        </span>
      </div>
    );
  }
  return (
    <div className={cn("flex flex-col items-center gap-2", className)}>
      <span className="text-center text-overline uppercase tracking-[0.2em] text-fg-subtle">Powered by</span>
      <div className="inline-flex w-fit items-center justify-center rounded-lg bg-[#0a0a0a] px-3 py-2">
        <img src={publicAsset("edx-logo.png")} alt="edx" width={88} height={32} className="h-6 w-auto" loading="lazy" decoding="async" />
      </div>
    </div>
  );
}
